import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    tokenExpire: null,
    tagsStoreList: [],
    language: Cookies.get("language") || "zh",
    userCompany: null,
    sysOrgs: [],
    currentOrg: null,
  },
  mutations: {
    saveToken(state, data) {
      state.token = data;
      window.localStorage.setItem("Token", data);
    },
    saveTokenExpire(state, data) {
      state.tokenExpire = data;
      window.localStorage.setItem("TokenExpire", data);
    },
    saveTagsData(state, data) {
      state.tagsStoreList = data;
      sessionStorage.setItem("Tags", data);
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_USERCOMPANY: (state, data) => {
      state.userCompany = data;
      localStorage.setItem("userCompany", JSON.stringify(data));
    },
    SET_SYSORGS: (state, data) => {
      state.sysOrgs = data;
      localStorage.setItem("sysOrgs", JSON.stringify(data));
    },
    SET_CURRENTORG: (state, data) => {
      state.currentOrg = data;
      localStorage.setItem("currentOrg", JSON.stringify(data));
    },
    SET_APPROVALCOMPETENCES: (state, data) => {
      state.ApprovalCompetences = data;
      localStorage.setItem("ApprovalCompetences", JSON.stringify(data));
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setUsercompany({ commit }, data) {
      commit("SET_USERCOMPANY", data);
    },
    setApprovalCompetences({ commit }, data) {
      commit("SET_APPROVALCOMPETENCES", data);
    },
    setSysOrgs({ commit }, data) {
      commit("SET_SYSORGS", data);
    },
    setCurrentOrg({ commit }, data) {
      commit("SET_CURRENTORG", data);
    },
  },
  getters: {
    getApprovalCompetences: (state) => {
      return (
        state.userCompany || JSON.parse(localStorage.getItem("ApprovalCompetences"))
      );
    },
    getUserCompany: (state) => {
      return (
        state.userCompany || JSON.parse(localStorage.getItem("userCompany"))
      );
    },
    getSysOrgs: (state) => {
      return state.sysOrgs && state.sysOrgs.length > 0
        ? state.sysOrgs
        : JSON.parse(localStorage.getItem("sysOrgs"));
    },
    getCurrentOrg: (state) => {
      return (
        state.currentOrg || JSON.parse(localStorage.getItem("currentOrg"))
      );
    },
  },
});
